if (!customElements.get('piecework-product-gallery')) {
  customElements.define(
    'piecework-product-gallery',
    class PieceworkProductGallery extends HTMLElement {
      constructor() {
        super();
        const sliderElement = this.querySelector('.splide');
        const sliderPagination = this.querySelectorAll(' .pw-media-pagination button');

        const slider = new Splide(sliderElement, {
          type: 'loop',
          arrows: false,
          pagination: false,
          focus: 'center',
          perPage: 3,
          perMove: 1,
          padding: { right: '10vw', left: '10vw' },
          breakpoints: {
            768: {
              perPage: 1,
              padding: { right: '10vw', left: '10vw' },
            },
          },
        }).mount();

        slider.on('move', () => {
          if (sliderPagination) {
            sliderPagination.forEach((page) => {
              const slide = parseInt(page.dataset.slide);
              if (slider.index === slide) {
                page.classList.add('tw-bg-current');
              } else {
                page.classList.remove('tw-bg-current');
              }
            });
          }
        });

        sliderPagination.forEach((button) => {
          button.addEventListener('click', () => {
            const gotoSlide = parseInt(button.dataset.slide);
            slider.go(gotoSlide);
          });
        });
      }
    }
  );
}
